export const MENU_CONSTS = {
    GET_MENUS: "GET_MENUS",
    GET_MENU_BY_ID: "GET_MENU_BY_ID",
    CREATE_MENU: "CREATE_MENU",
    DELETE_MENU_BY_ID: "DELETE_MENU_BY_ID",
};
